// extracted by mini-css-extract-plugin
export default {"slider":"Slider_slider__jHibB","imageContainer":"Slider_imageContainer__Qy7Kc","image":"Slider_image__sSdnS"};